import $ from 'jquery';

window.jQuery = $;
window.$ = $;

var homeAtl = {
    $container: null,
    $graphic: null,
    init: function () {
        homeAtl.$container = $('.main-slider');
        homeAtl.$graphic = homeAtl.$container.find('.slider-image');
        homeAtl.runAnimation();
        setTimeout(function () {
            let clutchScript = document.createElement('script');

            $('body').append(clutchScript);
            clutchScript.onload = function () {
                window.CLUTCHCO.Init();
            };
            clutchScript.src = 'https://widget.clutch.co/static/js/widget.js';
        }, 3500);
    },
    runAnimation: function () {
        let $StandardAnimations = $('.main-slider .dna-animation');

        $StandardAnimations
            .find('path').not('[fill="none"]')
            .each(function () {
                var length = this.getTotalLength();

                $(this).addClass('path').css({
                    'stroke-dasharray': length,
                    'stroke-dashoffset': length*-1
                });
            })
            .end()
            .find('[fill="#fff"]')
            .css('fill', 'transparent')
            .addClass('svg-draw-bg');
        homeAtl.$graphic.css('visibility', 'visible');
        homeAtl.$graphic
            .find('.black-quarter, .black-quarter2, .orange-quarter, .blue-ring')
            .find('circle')
            .addClass('excluded-circle animate');
        $('.clients-section').addClass('animate');
    }
};

$(function () {
    homeAtl.init();
});